"use client"

import { useTranslations } from "next-intl";
import {
    Card,
} from "@/theme/ui";
import { WalletsComponent } from "@/components/wallet/wallets";
import { WalletHistoryComponent } from "@/components/wallet/history";


export const WalletPageComponent = () => {
    const t = useTranslations('wallet');
    return (
        <>
            <Card
                title={t('title')}
                className={'roles'}
            >
                <WalletsComponent />
                <WalletHistoryComponent />
            </Card>
        </>
    );
}